import client from '../../providers/fetchClient'

export const getSigners = params => client.get('/v3/signers', { params })

export const getCurrentUserSigner = () => client.get('/v3/signers/me')
